<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="2" class="text-right white--text">
          
        </v-col>-->
        <v-col cols="7" class="text-right">
          <span class="white--text font-weight-bold dashboard_title">DashBoard</span>
          <v-menu bottom offset-x :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small dark v-bind="attrs" v-on="on">
                <v-badge overlap dot :value="search" color="error">
                  <v-icon class="white--text" size="25">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="300">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    dense
                    solo
                    clearable
                    v-on:keyup.enter="search_menu = false"
                    autofocus
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="5" class="text-right">
          <span class="white--text font-weight-bold">
            Exit
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>

    <v-card flat tile class="bg_light_grey" style="height:765px;overflow:hidden !important">
      <v-card-text class="pa-0 mx-auto">
        <v-container class="dashboard-wrapper">
          <!-- Transactions Section -->
          <div class="section-title text-center" style="font-size:18px;">Transactions</div>
          <v-row class="card-row" dense>
            <v-col
              v-for="item in transactionItems"
              :key="item.title"
              cols="auto"
              class="d-flex justify-center"
            >
              <v-card
                class="text-center card-border pa-2 ma-0 border-radius-card"
                outlined
                width="150"
                height="105"
                elevation="0"
                @click.native="handleClick(item, $event)"
              >
                <v-list-item-avatar tile size="40" class="mr-0 mt-2 avatar-icon">
                  <v-btn icon>
                    <v-icon size="25">{{ item.icon }}</v-icon>
                  </v-btn>
                </v-list-item-avatar>
                <div class="text-grey">{{ item.title }}</div>
              </v-card>
            </v-col>
          </v-row>

          <!-- Setup Section -->
          <div class="section-title text-center" style="font-size:18px;">Setup</div>
          <v-row class="card-row" dense>
            <v-col
              v-for="item in setupItems"
              :key="item.title"
              cols="auto"
              class="d-flex justify-center"
            >
              <v-card
                class="text-center card-border pa-2 ma-0 border-radius-card"
                outlined
                width="150"
                height="105"
                elevation="0"
                @click.native="handleClick(item, $event)"
              >
                <v-list-item-avatar tile size="40" class="mr-0 mt-2 avatar-icon">
                  <v-btn icon>
                    <v-icon size="25">{{ item.icon }}</v-icon>
                  </v-btn>
                </v-list-item-avatar>
                <div class="text-grey">{{ item.title }}</div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <DocList />
  </div>
</template>

<script>
import { logout } from "../../plugins/helper";
import { mapMutations, mapState } from "vuex";
import DocList from "../document/List";

export default {
  name: "Home",
  components: { DocList },
  data() {
    return {
      search_menu: "",
      search: "",
      transactionItems: [
        {
          title: "Customer",
          icon: "mdi-account-multiple-outline",
          route: "/customers"
        },
        { title: "New Construction", icon: "mdi-city", route: "/projects/1" },
        { title: "Remodeling", icon: "mdi-move-resize", route: "/projects/2" },
        {
          title: "Counter Tops",
          icon: "mdi-cart-outline",
          route: "/projects/3"
        },
        { title: "Misc Sales", icon: "mdi-church", route: "/projects/4" },

        {
          title: "Bank Transaction",
          icon: "mdi-bank-outline",
          action: "redirectToTransaction"
        },
        {
          title: "Invoice",
          icon: "mdi-cash-usd-outline",
          action: "redirectToInvoice"
        },
        {
          title: "Reports",
          icon: "mdi-file-outline",
          action: "redirectToReport"
        },
        { title: "Calendar", icon: "mdi-calendar-check", route: "/calendar" },
        {
          title: "Dox Upload",
          icon: "mdi-note-multiple-outline",
          action: "openDocList"
        }
      ],
      setupItems: [
        { title: "Area", icon: "mdi-map", route: "/area" },
        {
          title: "Calendar Task",
          icon: "mdi-calendar-check",
          route: "/task"
        },
        {
          title: "Chart of Account",
          icon: "mdi-file-account-outline",
          route: "/accounts"
        },
        {
          title: "Color",
          icon: "mdi-palette-outline",
          route: "/color"
        },
        {
          title: "Company Add",
          icon: "mdi-domain",
          action: "redirectToExternalCompany"
        },
        {
          title: "Company Setup",
          icon: "mdi-hospital-building",
          route: "/company_setup"
        },
        {
          title: "Document Type",
          icon: "mdi-note-multiple-outline",
          route: "/documenttype"
        },
        {
          title: "Email Domain",
          icon: "mdi-earth",
          route: "/domains"
        },
        {
          title: "Invoice Group",
          icon: "mdi-note-multiple-outline",
          route: "/invoicegroup"
        },
        {
          title: "Item Master",
          icon: "mdi-cube-outline",
          route: "/items"
        },
        {
          title: "UOM",
          icon: "mdi-scale",
          route: "/uom"
        },
        {
          title: "User",
          icon: "mdi-contacts-outline",
          route: "/users"
        },
        {
          title: "Vendor",
          icon: "mdi-quadcopter",
          route: "/vendors"
        },
        {
          title: "Vendor Type",
          icon: "mdi-contacts",
          route: "/vendortype"
        },
        {
          title: "Zip Code",
          icon: "mdi-qrcode",
          route: "/zip"
        }
      ]
    };
  },
  computed: {
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    login_user_name() {
      let user_name = localStorage.getItem("user_name");
      return user_name;
    }
  },
  watch: {
    doc_list_modal(value) {
      this.open_doc_model_flag = value;
    }
  },
  methods: {
    ...mapMutations("transaction", ["setTransactionData"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),

    logout() {
      logout(this.$router);
    },

    handleClick(item, event) {
      if (item.route) {
        if (event.ctrlKey || event.metaKey) {
          // Ctrl (Windows/Linux) or Cmd (Mac)
          window.open(this.$router.resolve(item.route).href, "_blank");
        } else {
          this.$router.push(item.route);
        }
      } else if (item.action && typeof this[item.action] === "function") {
        this[item.action]();
      } else {
        console.warn("No route or action defined for:", item.title);
      }
    },
    redirectToExternalCompany() {
      window.open("https://build-well.com/superadmin/#/company", "_blank");
    },
    redirectToInvoice() {
      this.setTransactionData({ key: "is_from_dashboard", value: true });
      this.$router.push("transaction");
    },

    redirectToReport() {
      localStorage.setItem("is_report_from_dashboard", true);
      this.$router.push("report/1");
    },

    redirectToTransaction() {
      localStorage.removeItem("is_from_project");
      localStorage.removeItem("co_group_id");
      localStorage.removeItem("co_item_id");
      localStorage.removeItem("co_project_id");
      localStorage.removeItem("co_co_id");
      localStorage.removeItem("redirect_to");
      localStorage.removeItem("is_from_dashboard");
      this.$router.push("transaction");
    },

    openDocList() {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 8 });
      this.setDocumentData({ key: "o_id", value: "" });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "item", value: "" });
      this.setDocumentData({ key: "form_name", value: "Project" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: "" });
      this.setDocumentData({ key: "bank_name", value: "" });
      this.setDocumentData({ key: "project_name", value: "" });
      this.setDocumentData({ key: "vendor_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "PROJECT" });
      this.setDocumentData({ key: "is_from_dashboard", value: true });
    }
  }
};
</script>

<style scoped>
.avatar-icon {
  border-radius: 20px !important;
  background-color: #d7ebbc;
}
.v-icon {
  color: #0b9d2f !important;
}
.text-grey {
  color: grey;
  font-size: 14px;
  line-height: 13px;
}
.card-border {
  box-shadow: 0px 10px 25px #d8d8d8 !important;
}
.bg_light_grey {
  background-color: #f6f6f6 !important;
}
.dashboard-wrapper {
  max-width: 900px;
  margin: 0 auto;
  padding: 10px 0;
  background-color: #f8f8f8;
}
.section-title {
  color: white;
  text-align: left;
  padding-left: 10px;
  background-color: #bdbdbd;
  padding: 8px;
  width: 90%;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.card-row {
  justify-content: center;
  margin-bottom: 20px;
  row-gap: 0px;
  column-gap: 0px;
}
.border-radius-card {
  border-radius: 20px !important;
}
.dashboard_title {
  padding-right: 65px;
}
</style>
